import cn from 'classnames';
import { formatDistance, differenceInMilliseconds } from 'date-fns';
import React, { useCallback } from 'react';
import { Badge } from 'react-bootstrap';
import text from '../../text';
import { statuses, statusLight } from './consts';
import { JobListing } from '../../redux/rtk';

const calculateETA = (leftTime: Date, rightTime: Date) => {
  const eta = differenceInMilliseconds(leftTime, rightTime);
  if (eta > 0) {
    return formatDistance(leftTime, rightTime);
  } else {
    return text('numberOfDays', { daysNumber: 0 });
  }
};

interface StatusProps {
  className: string;
  job: JobListing;
  suffix: string | null;
}

const Status = ({ className, job, suffix }: StatusProps) => {
  const getStatus = useCallback(() => {
    if (!job.status) {
      return null;
    }
    if (['pending', 'inprogress'].includes(job.status) && job.expected_at) {
      return (
        statuses[job.status].name +
        '\n' +
        text('expectedAt', {
          eta: calculateETA(new Date(job.expected_at), new Date()),
        })
      );
    }

    return statuses[job.status].name;
  }, [job]);

  return (
    <span className={cn('tblstatus', { [className]: className })}>
      {job.status === 'demo' ? (
        <Badge variant='info'>SAMPLE</Badge>
      ) : (
        <>
          <span className={`status-circle ${statusLight[job.status]}`} />
          <span>
            {getStatus()}
            <br />
            <span className='very-small'>
              <span>
                {job.completed_date
                  ? new Date(job.completed_date).getDate() +
                    '/' +
                    (new Date(job.completed_date).getMonth() + 1) +
                    '/' +
                    new Date(job.completed_date).getFullYear()
                  : ''}
              </span>
            </span>
          </span>
          {suffix ? <span className='grey-3 pl-2'>{suffix}</span> : null}
        </>
      )}
    </span>
  );
};

export default Status;
